import useMediaQuery from '@mui/material/useMediaQuery'
import { useNavigate } from 'react-router'

import { MOBILE_VIEWPORT } from '../../../../guided-toolbox/utils/breakpoints'

/**
 * Entry point for the statement upload flow.
 *
 * Desktop opens a modal over the current screen; mobile navigates to a dedicated page, which
 * is what the designs call for and also what lets the device's file picker take over the
 * viewport. Everything after the file is chosen is shared.
 *
 * @param {object} params
 * @param {object} params.store The app store.
 * @param {string} params.type
 * @param {string} params.accountType
 * @param {string|number} params.accountId
 * @returns {{ openUpload: () => void, isMobile: boolean }}
 */
const useStatementUpload = ({ store, type, accountType, accountId }) => {
  const navigate = useNavigate()
  const isMobile = useMediaQuery(MOBILE_VIEWPORT)

  const openUpload = () => {
    if (isMobile) {
      navigate(`/accounts/add/${type}/${accountType}/${accountId}/upload-statement`)
      return
    }

    store.openUploadModal({ type, accountType, accountId })
  }

  return { openUpload, isMobile }
}

export default useStatementUpload
